import type { Filters } from "./models";

/**
 * utility func used to set filter options if defined
 * @param filters
 * @param col
 * @param options
 */
export function setFilterOptions<T>(
  filters: Filters<T>,
  col: T,
  options: any[],
) {
  if (filters.filtersByColumn.has(col)) {
    filters.filtersByColumn.get(col)?.setOptions(options);
  }
}
